import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import App from './App';

// Create a root.
const root = ReactDOMClient.createRoot(document.querySelector('#root'));

// Initial render: Render an element to the root.
root.render(<App />);

// During an update, no need to pass the container again (i.e. document.querySelecter...)
// root.render(<App tab="profile" />);